<div #modal
     (hide.bs.modal)="onModalClose()"
     [id]="getId()"
     class="modal platform-link-copy-confirmation"
     data-keyboard="false" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">

                <button (click)="onModalClose()" class="close-button float-end" data-bs-dismiss="modal" title="Schließen"
                        type="button">
                    <i aria-hidden="true" class="fa fa-times"></i>
                </button>

                @if (platformLink) {
                    <app-platform-link-copied-confirmation
                            [platform]="platformLink"></app-platform-link-copied-confirmation>
                }


            </div>
            <div class="modal-footer platform">
                <button (click)="onModalClose()" class="close-platform-link-btn" data-bs-dismiss="modal">
                    Info schließen
                </button>
            </div>
        </div>
    </div>
</div>
